





























import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';
import { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element';

import { ColorEnum } from '../../enums';

import Badge from '../badge.component.vue';
import MutableList from '../mutable-list.component.vue';

interface RankingElementWithId extends RankingElement {
  id: string;
}

export default {
  name: 'ranking-elements-list',
  props: {
    elements: {
      type: Array, // RankingElement[]
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    MutableList,
    Badge
  },
  computed: {
    sortedElementsByAction: function (): RankingElementWithId[] {
      return this.elements
        .map((element: RankingElement) => ({
          ...element,
          id: this.getElementId(element)
        }))
        .sort((element1: RankingElementWithId, element2: RankingElementWithId) => {
          if (element1.action !== element2.action) {
            return ((element1.action === RankingActionEnum.BOOST) ? -1 : 1);
          }
          return 0;
        });
    }
  },
  methods: {
    getElementId: function (element: RankingElement): string {
      return `${ element.fieldName }-${ element.fieldValue }-${ element.action }`;
    },
    getIndexOfElement: function (element: RankingElementWithId): number {
      return this.elements.findIndex((el: RankingElement) => (this.getElementId(el) === element.id));
    },
    onRemoveElement: function (element: RankingElementWithId): void {
      this.elements.splice(this.getIndexOfElement(element), 1);
    },
    onMoveElement: function ({ item: elementToMove, targetIndex }): void {
      const { id: elementId, ...element } = elementToMove;
      const targetElement = this.sortedElementsByAction[targetIndex];
      const updatedElements = [...this.elements];
      const oldIndex = this.getIndexOfElement(elementToMove);
      const newIndex = this.getIndexOfElement(targetElement);
      updatedElements.splice(oldIndex, 1);
      updatedElements.splice(newIndex, 0, element);
      this.$emit('update:elements', updatedElements);
    },
    getActionColor: function (action: RankingActionEnum): ColorEnum {
      return {
        [RankingActionEnum.BOOST]: ColorEnum.GREEN,
        [RankingActionEnum.BURY]: ColorEnum.RED
      }[action];
    }
  }
};
